import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../translation/translation';
import toDangerousReactHtml from '../../helper/to_dangerous_react_html';

function SelectFSLightBoxContent(props) {
    const {
        onSelectMyTyreClick,
        onContinueShopping,
    } = props;

    return (
        <div className="select-fs-light-box__content select-fs-light-box-content">
            {props.error && !props.error.invalid && <>

                <p className="select-fs-light-box-content__why-alignment">
                    <Translation
                        tagName="b"
                        translationKey="select-fs-light-box-info-prefix"
                    />
                    {' '}
                    <Translation translationKey="select-fs-light-box-info" />
                    {' '}
                </p>

                <div className="select-fs-light-box-content__actions">
                    <Translation
                        tagName="button"
                        className="select-fs-light-box-content__action-accept"
                        onClick={onSelectMyTyreClick}
                        translationKey="select-fs-light-box-header-action-select-my-tyre"
                    />

                    <Translation
                        tagName="button"
                        className="select-fs-light-box-content__action-remove"
                        onClick={onContinueShopping}
                        translationKey="select-fs-light-box-header-action-continue-shopping"
                    />
                </div>
            </>
            }

            {props.error && props.error.invalid && <p
                name="error-remove-fs"
                className="select-fs-light-box-content__why-alignment floating-label-element__hint--invalid"
                style={{ border: 'none' }}
                dangerouslySetInnerHTML={toDangerousReactHtml(props.error.invalidMessage)}
            />
            }
        </div>
    );
}

SelectFSLightBoxContent.propTypes = {
    error: PropTypes.object,
    onSelectMyTyreClick: PropTypes.func.isRequired,
    onContinueShopping: PropTypes.func.isRequired,
};

export { SelectFSLightBoxContent };
